const timeline = {
  event: {
    minHeight: '5rem',
    progressive: {
      marker: {
        size: '0px',
        borderWidth: '0px',
        borderStyle: 'none',
      },
      connector: {
        size: '{sizes.xs}',
      },
    },
    connector: {
      backgroundColor: '#D8D8D8',
    },
  },
  horizontal: {
    eventContent: {
      padding: '0',
    },
  },
  vertical: {
    eventContent: {
      padding: '0 0 0 {spacing.xs}',
    },
  },
  eventMarker: {
    size: '1rem',
    borderRadius: '{border.radius.xl}',
    borderWidth: '4px',
    background: '{secondary.hover.color}',
    borderColor: '{content.border.color}',
    content: {
      size: '0',
    },
  },
  eventConnector: {
    color: '{content.border.color}',
    size: '3px',
  },
  color: {
    light: {
      primary: {
        color: '{primary.color}',
        marker: {
          background: '{primary.50}',
          border: '{primary.color}',
        },
        connector: {
          color: '{primary.border.color}',
        },
      },
      secondary: {
        color: '{secondary.color}',
        marker: {
          background: '{secondary.50}',
          border: '{secondary.color}',
        },
        connector: {
          color: '{secondary.border.color}',
        },
      },
      warning: {
        color: '{warning.color}',
        marker: {
          background: '{warning.hover.color}',
          border: '{warning.color}',
        },
        connector: {
          color: '{warning.border.color}',
        },
      },
      success: {
        color: '{success.color}',
        marker: {
          background: '{success.hover.color}',
          border: '{success.color}',
        },
        connector: {
          color: '{success.border.color}',
        },
      },
      error: {
        color: '{error.color}',
        marker: {
          background: '{error.hover.color}',
          border: '{error.color}',
        },
        connector: {
          color: '{error.border.color}',
        },
      },
      disabled: {
        color: '{disabled.color}',
        marker: {
          background: '{disabled.hover.color}',
          border: '{disabled.color}',
        },
        connector: {
          color: '{disabled.border.color}',
        },
      },
      monochrome: {
        color: '{monochrome.color}',
        marker: {
          background: '{monochrome.hover.color}',
          border: '{monochrome.color}',
        },
        connector: {
          color: '{monochrome.border.color}',
        },
      },
    },
  },
};

export default timeline;
